import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import DomesticTours from './pages/DomesticTours';
import InternationalTours from './pages/InternationalTours';
import TourDetails from './pages/TourDetails';
import BookingForm from './pages/BookingForm';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';

function App() {
  return (
    <Router>
      <div className="app-container">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/domestic" element={<DomesticTours />} />
            <Route path="/international" element={<InternationalTours />} />
            <Route path="/tour/:id" element={<TourDetails />} />
            <Route path="/book" element={<BookingForm />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/about" element={<AboutUs />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
